import React, { useCallback, useEffect } from 'react';
import Allocation from 'npo/pages/Tasks/Allocation';
import { useGraphQLRequest } from '../../auth/hooks/useApiRequest';
import {
  getAllNPOUsers,
  NPOUser,
} from 'npo/pages/ReportsBeta/NewProgram/api';
import { Program } from 'npo/pages/Reports/NewReportDialog';
import { Task } from 'npo/pages/Tasks/api';
import { useClient, useQueryRefresh } from '../../apollo';
import { parseProgramsAndYears, reportsQuery } from 'npo/pages/Tasks/Tasks';
import { getPrograms } from 'npo/pages/ReportsBeta/NewReport/api';
import { Report } from './utils';

interface AllocateReportModalProps {
  report: Report | undefined;
  task: Task | undefined;
  onClose: () => unknown;
}

const AllocateReportModal: React.FC<AllocateReportModalProps> = ({
  task,
  report,
  onClose,
}) => {
  const client = useClient();
  const { data: reportsData, refresh: onReportsRefresh } = useQueryRefresh(
    reportsQuery,
  );
  const [allNPOUsers, makeAllNPOUsersRequest] = useGraphQLRequest<{
    allUsers: NPOUser[];
  }>();
  const [allPrograms, makeAllProgramRequest] = useGraphQLRequest<{
    allPrograms: Program[];
  }>();

  const reloadPrograms = useCallback(() => {
    if (!client) return;
    const request = getPrograms(client);
    makeAllProgramRequest(request);
    return request;
  }, [makeAllProgramRequest, client]);

  const reloadNPOUser = useCallback(() => {
    client && makeAllNPOUsersRequest(getAllNPOUsers(client));
  }, [makeAllNPOUsersRequest, client]);

  useEffect(() => {
    reloadPrograms();
    reloadNPOUser();
  }, [reloadPrograms, reloadNPOUser]);

  if (!task) {
    return null;
  }

  return (
    <Allocation
      task={task}
      open={true}
      programNameByDonor={report?.programName}
      yearByDonor={report?.year}
      allReports={parseProgramsAndYears(reportsData)}
      allPrograms={allPrograms}
      allNPOUsers={allNPOUsers}
      handleClose={onClose}
      reloadTasks={() => window.location.reload()}
      reloadPrograms={reloadPrograms}
      reloadNPOUser={reloadNPOUser}
    />
  );
};

export default AllocateReportModal;
